import { usePrevious } from "@react-hookz/web";
import {
  MotionValue,
  useAnimate,
  useMotionValue,
  useTransform,
} from "motion/react";
import { ReactNode, useEffect } from "react";
import { sleep } from "../../../utils/sleep";
import { animationCurves } from "../../../utils/animationCurves";
import { AnimatedSplitLines } from "../../shared/AnimatedSplitLines";

export const InspoSlideTitleContent = ({
  index,
  currentIndex,
  entranceMv,
  children,
}: {
  index: number;
  currentIndex: number;
  entranceMv: MotionValue<number>;
  children: ReactNode;
}) => {
  const slideTransitionMv = useMotionValue(index === currentIndex ? 0 : -1);
  const [, animate] = useAnimate();
  const previousIndex = usePrevious(currentIndex);
  useEffect(() => {
    if (previousIndex === currentIndex) return;

    if (currentIndex === index) {
      sleep(animationCurves.default.duration).then(async () => {
        animate(slideTransitionMv, 0, animationCurves.long);
      });
    }

    if (previousIndex === index) {
      animate(slideTransitionMv, -1, animationCurves.long);
    }
  }, [previousIndex, currentIndex, slideTransitionMv, animate, index]);
  const splitLinesMv = useTransform(() =>
    Math.min(entranceMv.get(), slideTransitionMv.get())
  );

  return (
    <p
      aria-hidden={index !== currentIndex}
      className="text-heading-1 text-center text-balance max-w-7xl"
    >
      <AnimatedSplitLines value={splitLinesMv}>{children}</AnimatedSplitLines>
    </p>
  );
};
